<div class="container-fluid container-padding">
  @if (graphLoaded) {
    <button (click)="onPrint()" class="btn-print">{{ 'Print' | translate }}</button>
  }
  <app-report-header></app-report-header>
  <app-report-body (graphReady)="onGraphReady($event)"></app-report-body>
</div>
